import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import Logo from "./Logo";
import MaintenanceCountdown from "./MaintenanceCountdown";

export default function MaintenanceGate({ children }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const { pathname } = useLocation();
  const [state, setState] = useState({ enabled: false, message: "", loaded: false });

  useEffect(() => {
    const load = () => api.get("/maintenance/status").then((r) => setState({ ...r.data, loaded: true })).catch(() => setState((s) => ({ ...s, loaded: true })));
    const onBlocked = (e) => setState({ enabled: true, message: e.detail, loaded: true });
    load();
    const timer = setInterval(load, 30000);
    window.addEventListener("mql:maintenance", onBlocked);
    window.addEventListener("mql:maintenance-refresh", load);
    return () => { clearInterval(timer); window.removeEventListener("mql:maintenance", onBlocked); window.removeEventListener("mql:maintenance-refresh", load); };
  }, []);

  if (!state.loaded) return <div className="min-h-screen bg-[#101114]" />;
  const staff = user && (user.role === "owner" || user.role === "staff");
  if (!state.enabled || staff || pathname === "/login") {
    return (
      <>
        {state.enabled && staff && (
          <div data-testid="maintenance-staff-banner" className="bg-[#F06464] text-white text-xs font-bold text-center py-1.5">{t("maint.staff_banner")}</div>
        )}
        {!state.enabled && state.scheduled_at && (
          <MaintenanceCountdown startAt={state.scheduled_at} message={state.scheduled_message}
            onReached={() => window.dispatchEvent(new Event("mql:maintenance-refresh"))} />
        )}
        {children}
      </>
    );
  }
  return (
    <div data-testid="maintenance-page" className="min-h-screen bg-[#101114] flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <div className="flex justify-center mb-8"><Logo /></div>
        <Wrench className="mx-auto text-[#D4AF37] mb-6" size={40} />
        <h1 className="text-4xl sm:text-5xl font-black text-[#F5F3ED] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t("maint.title")}</h1>
        <p data-testid="maintenance-message" className="text-[#A8A8AD]">{state.message}</p>
        <p className="text-xs text-[#A8A8AD] mt-6">{t("maint.sub")}</p>
        <Link to="/login" data-testid="maintenance-staff-login-link" className="inline-block mt-10 text-[11px] uppercase tracking-[0.25em] text-[#A8A8AD]/70 hover:text-[#D4AF37] transition-colors">{t("maint.staff_login")}</Link>
      </div>
    </div>
  );
}
